import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-shabic',
  templateUrl: './icon-shabic.component.html',
  styleUrls: ['./icon-shabic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconShabicComponent {}
